export default __webpack_public_path__ + "img/icon-product.4daf6731.svg";